module.exports = __webpack_public_path__ + "static/media/badge-2-yellow.0dfaed6e.svg";